import React from 'react'
import { ButtonType } from '../../../../components/GenericButton/styles'
import { Typography } from '@mui/material'
import { useAppDispatch } from '../../../../store'
import { grey } from '../../../../colors'
import { deleteSectionApi, getSlotSectionApi } from '../../../../store/slices/distributionPlanSlice/apis'
import { deleteLoading } from '../../../../store/slices/distributionPlanSlice/selectors'
import { useTheme } from '@mui/material/styles'
import DefaultModalActions from '../../../../components/GenericModal/DefaultModalActions'
import { useParams } from 'react-router-dom'
import { type ISection } from '../../../../models/TermsSection'
import { type ApplyFiltersAndDispatchParams } from '../../../../components/CustomTable/types'
import { SlotStatus, type ISlot } from '../../../../models/DistributionPlan'
import { type ApiError } from '../../../../models/Common'
import { notification } from '../../../../components/Notifications'

interface CourseDeleteProps {
  selectedRow?: ISection
  handleCloseModal?: () => void
  showErrorModal?: () => void
  setErrorMessage?: (arg: string) => void
  params?: ApplyFiltersAndDispatchParams
  slot: ISlot

}

const CourseDelete: React.FC<CourseDeleteProps> = ({ selectedRow, handleCloseModal, showErrorModal, setErrorMessage, params, slot }) => {
  const dispatch = useAppDispatch()
  const isDeleteLoading = deleteLoading()
  const theme = useTheme()
  const { id } = useParams()

  const isSurveyLive = slot.slotNodeDetails?.slotStatus === SlotStatus.Live

  const handleDelete = async (): Promise<void> => {
    try {
      if (id && selectedRow?.linkedSection?.sectionId) {
        await dispatch(deleteSectionApi({ urlIds: [id, selectedRow?.linkedSection?.sectionId] })).unwrap().then(() => { handleCloseModal?.() })
        void dispatch(getSlotSectionApi({ urlId: id, params }))
      }
    } catch (error) {
      const customError = error as ApiError
      if (customError && customError.status === 422) {
        setErrorMessage?.(customError.message)
        showErrorModal?.()
        return
      }
      notification(customError?.message ?? 'Internal server error', { variant: 'error' })
    }
  }
  const message = isSurveyLive ? 'Deleting the Survey for this Course Section  will also permanently delete the collected responses. This does NOT delete the underlying Course Section. You can reassign this Course Section to this Survey Project later.' : 'This does <b>NOT</b> delete the underlying Course Section. You can reassign this Course Section to this Survey Project later'

  return (
    <>
         <Typography
      fontSize='14px'
      lineHeight={theme.spacing(5)}
      color={grey[850]}
      dangerouslySetInnerHTML={{ __html: message }}
    />
      <DefaultModalActions
        confirmButtonProps={{
          onClick: handleDelete,
          text: 'Delete',
          loading: isDeleteLoading,
          buttonType: ButtonType.Destructive
        }}
        destructiveButtonProps={{
          onClick: handleCloseModal
        }}
      />
    </>

  )
}

export default CourseDelete
